/** 店舗ID */
class StoreCd {
    /** 本部(本部管理者のID) */
    static SYSTEM_ADMIN = { code: "69" };
}
export { StoreCd };
